var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreyChai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    height: 300,
    id: "screenshot-1d8af7ff-090f-80c0-8002-992288f8ab49",
    viewBox: "0 0 300 300",
    style: {
      WebkitPrintColorAdjust: "exact"
    },
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-992288f8ab49",
    height: 48,
    width: 48,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-99206eeec358"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-99206eeec358"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M138.125,224.875C114.167,224.875,93.490,216.385,76.094,199.406C58.698,182.427,50.000,162.271,50.000,138.938L50.000,56.750C50.000,51.750,51.875,47.375,55.625,43.625C59.375,39.875,63.750,38.000,68.750,38.000L234.063,38.000C245.369,38.000,255.019,41.854,263.011,49.563C271.004,57.271,275.000,66.750,275.000,78.000C275.000,89.250,271.004,98.729,263.011,106.438C255.019,114.146,245.369,118.000,234.063,118.000L226.250,118.000L226.250,138.938C226.250,162.271,217.552,182.427,200.156,199.406C182.760,216.385,162.083,224.875,138.125,224.875ZL138.125,224.875ZM207.500,56.750L68.750,56.750M138.125,206.125C157.083,206.125,173.385,199.510,187.031,186.281C200.677,173.052,207.500,157.271,207.500,138.938L208.000,56.500C208.000,56.500,69.000,57.500,69.000,57.500L68.750,138.938C68.750,157.271,75.573,173.052,89.219,186.281C102.865,199.510,119.167,206.125,138.125,206.125ZL138.125,206.125ZM226.250,99.250L234.063,99.250C240.104,99.250,245.313,97.219,249.688,93.156C254.063,89.094,256.250,84.042,256.250,78.000C256.250,71.958,254.063,66.906,249.688,62.844C245.313,58.781,240.104,56.750,234.063,56.750L226.250,56.750L226.250,99.250ZL226.250,99.250ZM50.000,263.000L50.000,244.250L248.125,244.250L248.125,263.000L50.000,263.000ZL50.000,263.000Z",
    style: {
      fill: "rgb(87, 107, 124)",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-1d8af7ff-090f-80c0-8002-9922b4ee1bc4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-1d8af7ff-090f-80c0-8002-9922b4ee1bc4"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M60.258,121.014C60.258,121.014,55.967,120.278,63.316,116.049C68.345,113.156,83.109,106.186,91.433,106.381C115.601,106.948,89.878,121.817,113.313,116.641C143.394,109.996,154.422,104.126,166.463,104.268C187.462,104.516,172.321,116.338,182.320,116.456C196.986,116.630,207.577,109.005,212.436,106.812C217.296,104.619,216.424,107.859,216.424,107.859",
    style: {
      opacity: 1,
      fill: "rgb(87, 107, 124)",
      fillOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-1d8af7ff-090f-80c0-8002-9922b4ee1bc4",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    rx: 0,
    ry: 0,
    d: "M60.258,121.014C60.258,121.014,55.967,120.278,63.316,116.049C68.345,113.156,83.109,106.186,91.433,106.381C115.601,106.948,89.878,121.817,113.313,116.641C143.394,109.996,154.422,104.126,166.463,104.268C187.462,104.516,172.321,116.338,182.320,116.456C196.986,116.630,207.577,109.005,212.436,106.812C217.296,104.619,216.424,107.859,216.424,107.859",
    style: {
      opacity: 1,
      fill: "none",
      strokeWidth: 15,
      stroke: "rgb(87, 107, 124)",
      strokeOpacity: 1
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyChai);
export default __webpack_public_path__ + "static/media/grey_chai.24f174c460d88e3daedb98d13376d0d8.svg";
export { ForwardRef as ReactComponent };